import type { ProductCategoriesFilters } from '@app/pages/Warehouses/ProductCategories/types';

export const PF = 'product-categories';

export const initialFilters: ProductCategoriesFilters = {
  Page: 1,
  ItemsPerPage: 20,
  SearchTerm: '',
};
